import React from 'react';
import {render} from 'react-dom';
import GamesFilterGames from './GamesFilterGames.jsx';
import GamesFilterHead from './GamesFilterHead.jsx';
import page from 'page';

class GamesFilterNavigationLi extends React.Component {
	constructor(props){
		super(props);
	}
	
	render(){
		return (<li data-id={this.props.id} className={ this.props.id == this.props.page ?  "selected" : ""} onClick={this.props.goPage} >
			{this.props.id}
		</li>)
		
	}
}

class GamesFilterNavigation extends React.Component {

	constructor(props){
		super(props);
		this.goPage = this.goPage.bind(this);
	}
	goPage(e){
		e.preventDefault();
		if($(e.target).attr("data-id") != this.props.page){
			paginationData.page = $(e.target).attr("data-id");
			if($(e.target).attr("data-id") != 1){
				if(paginationData.first && paginationData.second){
					page("/"+paginationData.first+"/"+paginationData.second+"/"+$(e.target).attr("data-id")+"#"+paginationData.sortBy);
				}
				else if(paginationData.first){
					page("/"+paginationData.first+"/"+$(e.target).attr("data-id")+"#"+paginationData.sortBy);
				}
				else{
					page("/"+$(e.target).attr("data-id")+"#"+paginationData.sortBy);
				}
			}
			else{
				if(paginationData.first && paginationData.second){
					page("/"+paginationData.first+"/"+paginationData.second+"/#"+paginationData.sortBy);
				}
				else if(paginationData.first){
					page("/"+paginationData.first+"/#"+paginationData.sortBy);
				}
				else{
					page("/#"+paginationData.sortBy);
				}
			}
		}
		if(paginationData.section != "gfyw"){
			$('html,body').animate({
              scrollTop: $("#GamesFilterGames").offset().top-60
            }, 1000);
		}
		else{
			$('html,body').animate({
              scrollTop: $(".gfyw-container").offset().top-60
            }, 1000);
		}
		 
	}
	render () {
		var rows = [];
		for (var i = 1; i <= this.props.totalPages; i++) {
			rows.push(<GamesFilterNavigationLi id={i} key={i} goPage={this.goPage} page={this.props.page} />)
		}
		return (
					<ul className="Games-pagination-pages">
						{rows}
					</ul>
				)
	}
}
export default GamesFilterNavigation;
